import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Search, Heart, ShoppingBag, LayoutGrid } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function MobileBottomNav() {
  const { count, setOpen } = useCart();
  const loc = useLocation();
  const active = (p) => loc.pathname === p;
  const item = (to, Icon, label, testid, onClick) => (
    onClick ? (
      <button onClick={onClick} data-testid={testid} className="flex flex-col items-center gap-1 flex-1 py-2 text-sharoa-charcoal">
        <div className="relative"><Icon size={20} />{label === "Bag" && count > 0 && <span className="absolute -top-1.5 -right-2 bg-sharoa-rose text-white text-[8px] w-3.5 h-3.5 rounded-full flex items-center justify-center">{count}</span>}</div>
        <span className="text-[10px]">{label}</span>
      </button>
    ) : (
      <Link to={to} data-testid={testid} className={`flex flex-col items-center gap-1 flex-1 py-2 ${active(to) ? "text-sharoa-rose" : "text-sharoa-charcoal"}`}>
        <Icon size={20} /><span className="text-[10px]">{label}</span>
      </Link>
    )
  );
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-sharoa-line flex items-center">
      {item("/", Home, "Home", "bottom-home")}
      {item("/shop", LayoutGrid, "Shop", "bottom-shop")}
      {item("/shop", Search, "Search", "bottom-search")}
      {item("/account?tab=wishlist", Heart, "Wishlist", "bottom-wishlist")}
      {item(null, ShoppingBag, "Bag", "bottom-bag", () => setOpen(true))}
    </nav>
  );
}
